import { defineComponent as _defineComponent } from 'vue'
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import { Badge } from '@/components/docs-main/reference-pages/badge';
import CopyUrlButton from '@/components/ui/buttons/CopyUrlButton.vue';
import type { MethodHeaderProp } from '@/components/docs-main/reference-pages/method/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'MethodHeader',
  props: {
    entity: null
  },
  setup(__props: any) {



return { __sfc: true,DocIcon, Badge, CopyUrlButton }
}

})